import { ref } from 'vue'
import request from '@/utils/request'

let _cachedSeriesList = null
let _cachePromise = null

/**
 * 缓存版本号：拉取完成后自增。
 * 读取函数内读取它，使调用方 computed 建立响应式依赖——修复「刷新/直开页面时
 * 首帧渲染早于异步预加载，Vue 对无依赖 computed 永久缓存空结果 → 下拉无选项」。
 */
const _version = ref(0)

export const TOP_SERIES_PRODUCT_TYPE_OPTIONS = [
  { value: 'device', label: '设备' },
  { value: 'filter', label: '滤芯' },
  { value: 'parts', label: '零配件' },
  { value: 'material', label: '物料' },
  { value: 'device_combo', label: '设备组合' },
  { value: 'filter_combo', label: '滤芯组合' },
  { value: 'other_combo', label: '其他组合' },
]

async function ensureCache() {
  if (_cachedSeriesList) return
  if (_cachePromise) { await _cachePromise; return }
  _cachePromise = request({ url: '/product-series/select-options', method: 'get' })
    .then(res => {
      if (res.code === 0) {
        const list = res.dataList || []
        if (Array.isArray(list) && list.length > 0) {
          _cachedSeriesList = list
          return
        }
      }
      _cachedSeriesList = []
    })
    .catch(() => { _cachedSeriesList = [] })
  await _cachePromise
  _version.value += 1
}

export async function refreshSeriesCache() {
  _cachedSeriesList = null
  _cachePromise = null
  await ensureCache()
}

export async function preloadProductSeries() {
  await ensureCache()
}

export async function getProductSeriesPage(params) {
  return request({ url: '/product-series/page', method: 'get', params })
}

// BUG-043：全量统计（total/enabled/disabled），底部统计条专用，不受分页影响
export async function getProductSeriesStats() {
  return request({ url: '/product-series/stats', method: 'get' })
}

export async function getProductSeriesDetail(id) {
  return request({ url: `/product-series/${id}`, method: 'get' })
}

export async function createProductSeries(data) {
  const res = await request({ url: '/product-series', method: 'post', data })
  await refreshSeriesCache()
  return res
}

export async function updateProductSeries(id, data) {
  const res = await request({ url: `/product-series/${id}`, method: 'post', data })
  await refreshSeriesCache()
  return res
}

export async function deleteProductSeries(id) {
  const res = await request({ url: `/product-series/${id}/delete`, method: 'post' })
  await refreshSeriesCache()
  return res
}

export async function updateProductSeriesStatus(id, status) {
  const res = await request({ url: `/product-series/${id}/status`, method: 'post', data: { status } })
  await refreshSeriesCache()
  return res
}

export async function updateProductSeriesSort(id, sortOrder) {
  return request({ url: `/product-series/${id}/sort`, method: 'post', data: { sortOrder } })
}

export function getEnabledEndSeriesSelectOptions() {
  void _version.value
  if (!_cachedSeriesList) return []
  return _cachedSeriesList
    .filter(r => r.value && r.label)
    .map(r => ({ value: r.value, label: r.label }))
}

export function productSeriesLabel(value) {
  void _version.value
  if (value == null || value === '') return '—'
  if (!_cachedSeriesList) return String(value)
  const node = _cachedSeriesList.find(r => r.value === value)
  return node ? node.label : String(value)
}

export function getSeriesPathLabel(code) {
  return productSeriesLabel(code)
}
